import type { TOC } from '@ember/component/template-only';
import { PrismBadge, PrismIcon } from '@mylighthouse/prism-ember';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import { t } from 'ember-intl';

import styles from './legend.module.css';

interface HotelChannelPricingLegendSignature {
  Args: {};
}

const HotelChannelPricingLegend: TOC<HotelChannelPricingLegendSignature> =
  <template>
    <div class="flex items-center gap-100">
      <PrismIcon @name="circle-information-outline" @size="small" />
      <span class="text-300--medium">{{t "channel_pricing.legend.label"}}</span>
      <EmberTooltip @side="bottom" @tooltipClass="default-tooltip p-500 mt-0">
        <div class="flex flex-col gap-400">
          <div class="flex flex-col gap-200">
            <p class="text-200--medium text-neutral-subdued">{{t
                "channel_pricing.legend.header.intelligence"
              }}</p>
            <div class="flex items-center gap-400">
              {{! Note: w-600 (24px) is used for icon container width throughout this legend.
                While not semantically ideal (it's a spacing token), it maintains consistency. }}
              <span class="flex w-600 items-center justify-center">
                <div class={{styles.recommendation-indicator}} />
              </span>
              <p class="text-200--regular">{{t
                  "channel_pricing.legend.item.recommendations"
                }}</p>
            </div>
            <div class="flex items-center gap-400">
              <span class="flex w-600 items-center justify-center">
                <PrismBadge @badgeType="intelligence" @label="3" />
              </span>
              <p class="text-200--regular">{{t
                  "channel_pricing.legend.item.multiple_recommendations"
                }}</p>
            </div>
            <div class="flex items-center gap-400">
              <span class="flex w-600 items-center justify-center">
                <PrismIcon
                  @color="intelligence"
                  @name="automation"
                  @size="small"
                />
              </span>
              <p class="text-200--regular">{{t
                  "channel_pricing.legend.item.autopilot_active"
                }}</p>
            </div>
          </div>
          <div class={{styles.divider}} />
          <div class="flex flex-col gap-200">
            <p class="text-200--medium text-neutral-subdued">{{t
                "channel_pricing.legend.header.pricing"
              }}</p>
            <div class="flex items-center gap-400">
              <span class="flex w-600 items-center justify-center">
                <PrismIcon @color="info" @name="bullet" @size="small" />
              </span>
              <p class="text-200--regular">{{t
                  "channel_pricing.legend.item.manual_overrides"
                }}</p>
            </div>
            <div class="flex items-center gap-400">
              <span class="flex w-600 items-center justify-center">
                <PrismIcon @name="meals-bed-and-breakfast" @size="small" />
              </span>
              <p class="text-200--regular">{{t
                  "channel_pricing.legend.item.breakfast_included"
                }}</p>
            </div>
          </div>
          <div class={{styles.divider}} />
          <div class="flex flex-col gap-200">
            <p class="text-200--medium text-neutral-subdued">{{t
                "channel_pricing.legend.header.channels_rate_match"
              }}</p>
            <div class="flex items-center gap-400">
              <span class="flex w-600 items-center justify-center">
                <PrismIcon @name="discount-filled" @size="small" />
              </span>
              <p class="text-200--regular">{{t
                  "channel_pricing.legend.item.not_matching_lower_price"
                }}</p>
            </div>
            <div class="flex items-center gap-400">
              <span class="flex w-600 items-center justify-center">
                <PrismIcon @name="circle-checkmark" @size="small" />
              </span>
              <p class="text-200--regular">{{t
                  "channel_pricing.legend.item.matching_price"
                }}</p>
            </div>
          </div>
          <div class={{styles.divider}} />
          <div class="flex flex-col gap-200">
            <p class="text-200--medium text-neutral-subdued">{{t
                "channel_pricing.legend.header.acronyms"
              }}</p>
            <div class="flex items-center gap-400">
              <span class="flex w-600 items-center justify-center">
                <span class="text-200--medium">{{t "rates.los"}}</span>
              </span>
              <p class="text-200--regular">{{t
                  "channel_pricing.legend.item.los"
                }}</p>
            </div>
            <div class="flex items-center gap-400">
              <span class="flex w-600 items-center justify-center">
                <span class="text-200--medium">{{t "rates.OTB"}}</span>
              </span>
              <p class="text-200--regular">{{t
                  "channel_pricing.legend.item.otb"
                }}</p>
            </div>
          </div>
        </div>
      </EmberTooltip>
    </div>
  </template>;

export default HotelChannelPricingLegend;
